import { render } from "./ModalFaq.vue?vue&type=template&id=6274a5a0&scoped=true"
import script from "./ModalFaq.vue?vue&type=script&lang=js"
export * from "./ModalFaq.vue?vue&type=script&lang=js"

import "./ModalFaq.vue?vue&type=style&index=0&id=6274a5a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6274a5a0"]])

export default __exports__